import { Helmet } from 'react-helmet-async'
import { ProfileForm } from '@/components/account/profile-form'
import { AddressForm } from '@/components/account/address-form'
import { PasswordChangeForm } from '@/components/account/password-change-form'
import { useAuth } from '@/hooks/useAuth'
import { Loader2 } from 'lucide-react'
import type { ShippingAddress } from '@/types/database'
import { getPageTitle } from '@/lib/branding'

export function AccountProfilePage() {
  const { customerProfile, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="flex items-center justify-center py-12">
        <Loader2 className="h-8 w-8 animate-spin text-muted-foreground" />
      </div>
    )
  }

  if (!customerProfile) {
    return (
      <div className="max-w-2xl mx-auto">
        <p className="text-muted-foreground">Profile not found. Please try signing in again.</p>
      </div>
    )
  }

  return (
    <>
      <Helmet>
        <title>{getPageTitle('Profile')}</title>
      </Helmet>
      <div className="max-w-2xl mx-auto space-y-8">
        <div>
          <h1 className="text-2xl font-bold">Profile</h1>
          <p className="text-muted-foreground mt-1">
            Manage your personal information
          </p>
        </div>

        <ProfileForm profile={customerProfile} />
        <AddressForm
          profileId={customerProfile.id}
          address={customerProfile.default_shipping_address as ShippingAddress | null}
        />
        <PasswordChangeForm />
      </div>
    </>
  )
}
